import { FunctionComponent } from 'react';
import markImg from '../../img/vdr-mark.png';

type Props = {
  /** Sobre fondo oscuro "Visión" va en blanco; sobre claro, en tinta. "DERRED" siempre en cian. */
  onDark?: boolean;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  /** Ícono hexagonal a la izquierda. Por defecto se muestra en 'sm' y 'md' (barras y pie). */
  withMark?: boolean;
  className?: string;
};

/**
 * Logotipo de VisiónDERRED: el ícono hexagonal del proyecto en la gama cian de la marca
 * (img/vdr-mark.png, con los nodos transparentes para que funcione sobre tinta y sobre blanco)
 * más el nombre como en la ficha de centra.uai.cl: Archivo 800, "Visión" en tinta o blanco y
 * "DERRED" en cian. Estilos en css/tokens.css (.vdr-wordmark).
 */
const VdrWordmark: FunctionComponent<Props> = ({ onDark = false, size = 'md', withMark, className = '' }) => {
  const showMark = withMark ?? (size === 'sm' || size === 'md');
  const classes = ['vdr-wordmark', `vdr-wordmark--${size}`];
  if (onDark) classes.push('vdr-wordmark--on-dark');
  if (className) classes.push(className);

  return (
    <span className={classes.join(' ')} role='img' aria-label='VisiónDERRED'>
      {showMark && <img src={markImg} alt='' aria-hidden='true' className='vdr-wordmark__mark' />}
      <span className='vdr-wordmark__lead' aria-hidden='true'>
        Visión
      </span>
      <span className='vdr-wordmark__accent' aria-hidden='true'>
        DERRED
      </span>
    </span>
  );
};

export default VdrWordmark;
